import { render, staticRenderFns } from "./ledgerDetail.vue?vue&type=template&id=2b092cd6&scoped=true&"
import script from "./ledgerDetail.vue?vue&type=script&lang=js&"
export * from "./ledgerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ledgerDetail.vue?vue&type=style&index=0&id=2b092cd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b092cd6",
  null
  
)

export default component.exports